// import { useEffect, useRef, useState } from 'react';
// import axios from "axios";
// import './project-demo.css';
// import { NavBar } from '../navbar/navbar';

// export function ProjectDemo() {


//     const [projects, setProjects] = useState([]);

//     function LoadProject() {
//         axios
//             .get("/projectData.json")
//             .then((res) => {
//                 setProjects(res.data);
//             })
//             .catch((err) => {
//                 alert('Error fetching projects')
//             });
//     }

//     useEffect(() => {
//         LoadProject()
//     }, []);



//     // const [leftSwapImg, setLeftSwapImg] = useState('leftSwap.svg')
//     // const [rightSwapImg, setrightSwapImg] = useState('rightSwp.svg')

//     let count = useRef(0)

//     function handleNextProject() {
//         if (count.current < lengthProj - 1) {
//             count.current = count.current + 1;
//             LoadProject();
//         }
//     }

//     function handlePrevProject() {
//         if (count.current > 0) {
//             count.current = count.current - 1;
//             LoadProject();
//         }

//     }

//     const [lengthProj, setLengthProj] = useState(0)

//     useEffect(() => {
//         axios.get("/projectData.json")
//             .then(lenProj => {
//                 setLengthProj(lenProj.data.length);
//             })
//     }, [])


//     return (
//         <div className="container-fluid bg bg-black d-flex justify-content-center align-items-center" style={{ height: "100vh", width: "100%" }}>
//             <div className="projectDiv ">

//                 {/* Heading */}
//                 <div className="projectHead z-1">
//                     <h1 className="head-proj">My Projects</h1>
//                     <div className="d-flex justify-content-between align-items-center mt-4">
//                         <div className="d-flex align-items-center gap-2">
//                             <span className="text-light-emphasis fw-bold fs-5">{count.current + 1}</span>
//                             <span className="text-light fs-6">/</span>
//                             <span className="text-light-emphasis fw-bold fs-5">{lengthProj}</span>
//                         </div>

//                         <button className="btn  swap-btn" onClick={handlePrevProject} ><img className="swap-icon" src="leftSwap.svg" alt="" /></button>
//                         <button className="btn  swap-btn" onClick={handleNextProject}><img className="swap-icon" src="rightSwp.svg" alt="" /></button>
//                     </div>
//                 </div>

//                 {/* body Part */}
//                 <div className="projectBody d-flex">
//                     <div className='bodyPartFirtst w-50 h-100 z-2'>
//                         <div>
//                             <h3 className='fs-2 fw-bold text-light'>{projects.length > 0 ? projects[count.current].title : "Loading..."}</h3>
//                         </div>

//                         <div className="bodyDesc">
//                             <span >
//                                 <p className='text-light-emphasis fw-bold p-2'>{projects.length > 0 ? projects[count.current].desc : "Loading..."}</p>
//                             </span>
//                         </div>
//                         <div>
//                             <h6 className='techUsed text-light fw-bold mt-3 mb-3'>Core Technologies:</h6>
//                             <div>

//                                 {projects.length > 0 && projects[count.current].skills.map((skill, index) => (
//                                     <span
//                                         key={index}
//                                         className='techUsedSkills fw-bold text-light border border-light border-1 p-2 rounded'
//                                         style={{ fontSize: "0.7rem", marginRight: "5px" }}>
//                                         {skill}
//                                     </span>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                     <div className='bodyPartSecond w-75 h-100 z-1'>
//                         <img src={projects.length > 0 ? projects[count.current].image : "Loading..."} alt="" />
//                     </div>
//                 </div>

//             </div>

//             <div className='mob-project'>
//                 <div className='heading-mob-proj-main' >
//                     <div className='heading-mob-proj'>My Projects</div>
//                     <div>
//                         <button className="btn  swap-btn" onClick={handlePrevProject} ><img className="swap-icon" src="leftSwap.svg" alt="" /></button>
//                         <button className="btn  swap-btn" onClick={handleNextProject}><img className="swap-icon" src="rightSwp.svg" alt="" /></button>
//                     </div>
//                 </div>
//                 <div className='mob-proj-img'>
//                     <img src={projects.length > 0 ? projects[count.current].image : "Loading..."} alt="" />
//                 </div>
//                 <div className='mob-proj-head-desc'>
//                     <span className='fs-2 fw-bold text-light'>
//                         {projects.length > 0 ? projects[count.current].title : "Loading..."}
//                     </span>
//                 </div>
//                 <div className='mob-proj-tech'>
//                     <h6 className='techUsed text-light fw-bold mt-3 mb-3'>Core Technologies:</h6>
//                     <div>
//                         {projects.length > 0 && projects[count.current].skills.map((skill, index) => (
//                             <span
//                                 key={index}
//                                 className='techUsedSkills fw-bold text-light border border-light border-1 p-2 rounded'
//                                 style={{ fontSize: "0.7rem", marginRight: "5px" }}>
//                                 {skill}
//                             </span>
//                         ))}
//                     </div>
//                 </div>
//                 <div className='mob-proj-dsc-sub'>
//                     <span >
//                         <p>{projects.length > 0 ? projects[count.current].desc : "Loading..."}</p>
//                     </span>
//                 </div>
//             </div>

//         </div>

//     )
// }





import { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import './project-demo.css';
import { NavBar } from '../navbar/navbar';

export function ProjectDemo() {

    const [projects, setProjects] = useState([]);
    const [lengthProj, setLengthProj] = useState(0);
    const [current, setCurrent] = useState(0);
    const [direction, setDirection] = useState(0); // -1 for left, 1 for right

    useEffect(() => {
        axios.get("/projectData.json")
            .then((res) => {
                setProjects(res.data);
                setLengthProj(res.data.length);
            })
            .catch(() => alert('Error fetching projects'));
    }, []);

    // handle next and previous
    const handleNextProject = () => {
        if (current < lengthProj - 1) {
            setDirection(1);
            setCurrent(current + 1);
        }
    };

    const handlePrevProject = () => {
        if (current > 0) {
            setDirection(-1);
            setCurrent(current - 1);
        }
    };

    // Framer motion variants for left/right transitions
    const variants = {
        enter: (direction) => ({
            x: direction > 0 ? 300 : -300,
            opacity: 0,
        }),
        center: {
            x: 0,
            opacity: 1,
            transition: { duration: 0.6, ease: "easeOut" },
        },
        exit: (direction) => ({
            x: direction > 0 ? -300 : 300,
            opacity: 0,
            transition: { duration: 0.6, ease: "easeIn" },
        }),
    };

    return (
        <div className="container-fluid bg bg-black d-flex justify-content-center align-items-center" style={{ height: "100vh", width: "100%" }}>
            <div className="projectDiv">
                {/* Heading */}
                <div className="projectHead z-1">
                    <h1 className="head-proj">My Projects</h1>
                    <div className="d-flex justify-content-between align-items-center mt-4">
                        <div className="d-flex align-items-center gap-2">
                            <span className="text-light-emphasis fw-bold fs-5">{current + 1}</span>
                            <span className="text-light fs-6">/</span>
                            <span className="text-light-emphasis fw-bold fs-5">{lengthProj}</span>
                        </div>

                        <div>
                            <button className="btn swap-btn" onClick={handlePrevProject}>
                                <img className="swap-icon" src="leftSwap.svg" alt="prev" />
                            </button>
                            <button className="btn swap-btn" onClick={handleNextProject}>
                                <img className="swap-icon" src="rightSwp.svg" alt="next" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Body Part */}
                <div className="projectBody d-flex position-relative overflow-hidden" style={{width:"85%"}}>
                    <AnimatePresence custom={direction}>
                        {projects.length > 0 && (
                            <motion.div
                                key={current}
                                custom={direction}
                                variants={variants}
                                initial="enter"
                                animate="center"
                                exit="exit"
                                className="d-flex w-100 position-absolute"
                            >
                                <div className='bodyPartFirtst w-50 h-100 z-2'>
                                    <div>
                                        <h3 className='fs-2 fw-bold text-light'>{projects[current].title}</h3>
                                    </div>

                                    <div className="bodyDesc">
                                        <p className='text-light-emphasis fw-bold p-2'>{projects[current].desc}</p>
                                    </div>

                                    <div>
                                        <h6 className='techUsed text-light fw-bold mt-3 mb-3'>Core Technologies:</h6>
                                        <div>
                                            {projects[current].skills.map((skill, index) => (
                                                <span
                                                    key={index}
                                                    className='techUsedSkills fw-bold text-light border border-light border-1 p-2 rounded'
                                                    style={{ fontSize: "0.7rem", marginRight: "5px" }}>
                                                    {skill}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className='bodyPartSecond z-1' style={{width:"400px"}} >
                                    <a target="_blank" href={projects[current].link}>
                                        <img src={projects[current].image} alt="" />
                                    </a>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>

            {/* Mobile Section */}
            <div className='mob-project'>
                <div className='heading-mob-proj-main'>
                    <div className='heading-mob-proj'>My Projects</div>
                    <div>
                        <button className="btn swap-btn" onClick={handlePrevProject}>
                            <img className="swap-icon" src="leftSwap.svg" alt="prev" />
                        </button>
                        <button className="btn swap-btn" onClick={handleNextProject}>
                            <img className="swap-icon" src="rightSwp.svg" alt="next" />
                        </button>
                    </div>
                </div>

                <AnimatePresence custom={direction}>
                    {projects.length > 0 && (
                        <motion.div
                            key={current}
                            custom={direction}
                            variants={variants}
                            initial="enter"
                            animate="center"
                            exit="exit"
                            className="w-100"
                        >
                            <div className='mob-proj-img'>
                                <img src={projects[current].image} alt="" />
                            </div>
                            <div className='mob-proj-head-desc'>
                                <span className='fs-2 fw-bold text-light'>
                                    {projects[current].title}
                                </span>
                            </div>
                            <div className='mob-proj-tech'>
                                <h6 className='techUsed text-light fw-bold mt-3 mb-3'>Core Technologies:</h6>
                                <div>
                                    {projects[current].skills.map((skill, index) => (
                                        <span
                                            key={index}
                                            className='techUsedSkills fw-bold text-light border border-light border-1 p-2 rounded'
                                            style={{ fontSize: "0.7rem", marginRight: "5px" }}>
                                            {skill}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            <div className='mob-proj-dsc-sub'>
                                <p className='text-light-emphasis fw-bold p-2'>{projects[current].desc}</p>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
}
